import { Button, CharField, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import { useNavigate } from "react-router-dom"
import Layout from "../../components/Layout"
import { useQsFilters } from "../../hooks/filters"
import { useGroupsOfResearchesList } from "../../hooks/group-of-researches"
import type { FiltersBase } from "../../types"
import { TableGroupOfResearchess } from "./TableGroupOfResearches"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "name",
  }) as FiltersBase

export default function GroupsOfResearches() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data } = useGroupsOfResearchesList({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
  })

  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Gruppi di ricerca" }])

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>Gruppi di ricerca</H1>
          <Button
            size="md"
            className="text-white"
            title="Aggiungi"
            leadingIcon="add"
            onClick={() => {
              navigate("/group-of-researches/group-of-researches/new")
            }}
          />
        </Flex>
        <Flex className="mb-3">
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value, page: 1 })
            }}
          />
        </Flex>
        <TableGroupOfResearchess
          groupsOfResearches={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
        />
      </Flex>
    </Layout>
  )
}
